import React from 'react';
interface Star {
  top: string;
  left: string;
  delay: string;
  duration: string;
  size: 'sm' | 'lg';
}
const stars: Star[] = [{
  top: '8%',
  left: '12%',
  delay: '0s',
  duration: '3.2s',
  size: 'sm'
}, {
  top: '15%',
  left: '78%',
  delay: '1.1s',
  duration: '4s',
  size: 'lg'
}, {
  top: '22%',
  left: '45%',
  delay: '0.5s',
  duration: '3.5s',
  size: 'sm'
}, {
  top: '35%',
  left: '88%',
  delay: '2s',
  duration: '3.8s',
  size: 'sm'
}, {
  top: '42%',
  left: '5%',
  delay: '0.8s',
  duration: '4.2s',
  size: 'lg'
}, {
  top: '55%',
  left: '65%',
  delay: '1.5s',
  duration: '3s',
  size: 'sm'
}, {
  top: '68%',
  left: '25%',
  delay: '0.3s',
  duration: '3.6s',
  size: 'sm'
}, {
  top: '75%',
  left: '92%',
  delay: '1.8s',
  duration: '4.5s',
  size: 'lg'
}, {
  top: '82%',
  left: '50%',
  delay: '2.2s',
  duration: '3.3s',
  size: 'sm'
}, {
  top: '90%',
  left: '15%',
  delay: '0.7s',
  duration: '3.9s',
  size: 'sm'
}, {
  top: '5%',
  left: '55%',
  delay: '1.3s',
  duration: '4.1s',
  size: 'sm'
}, {
  top: '48%',
  left: '35%',
  delay: '2.5s',
  duration: '3.4s',
  size: 'lg'
}];
export function StarField() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-301">
      {stars.map((star, i) => <div key={i} className={`star ${star.size === 'lg' ? 'star-lg' : ''}`} style={{
      top: star.top,
      left: star.left,
      animationDelay: star.delay,
      animationDuration: star.duration
    }} data-id="element-302" />)}
    </div>;
}